import { Component, ContentChildren, Input, QueryList, OnInit } from '@angular/core';

import { TabComponent } from './tab.component';
import { TabStateService } from './tab-state.service';

@Component({
  selector: 'fin-tab-group',
  templateUrl: 'tab-group.component.html',
  providers: [TabStateService],
})
export class TabGroupComponent implements OnInit {
  @Input()
  tabGroupId: string;

  @ContentChildren(TabComponent)
  tabs: QueryList<TabComponent>;

  constructor(private service: TabStateService) {}

  ngOnInit(): void {
    this.service.init(this.tabGroupId);
  }
}
